// /settings/directory — «Справочник» (005 T033, 005-3 FR-008, FR-018): порог пары «тот же?»,
// порог вида по оценке ИИ, лимит вопросов ИИ о виде. Право — settings.write.
import { createFileRoute } from '@tanstack/react-router';
import { DirectorySettingsPage } from '../../../features/settings/DirectorySettingsPage.tsx';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/settings/directory')({
  beforeLoad: requireSection('settings'),
  staticData: { crumb: 'Справочник' },
  component: DirectorySettingsPage,
});
